import { useQuery } from '@tanstack/react-query';
import { getAuditorVisitRepReviewForMe } from '@/features/audit-visitrepreview/api/getAuditorVisitRepReviewForMe';

// TODO: Refactor this - maybe an endpoint to check reminders status or add it in token
export const useDoesUserHaveAnyVisitRepReviews = (isAuditor = false): boolean => {
  const query = useQuery({
    enabled: isAuditor,
    queryKey: ['does-user-have-any-visit-repreviews'],
    queryFn: () =>
      getAuditorVisitRepReviewForMe({
        page: 1,
        pageSize: 100,
        search: '',
        sortBy: null,
        filters: null,
      }),
  });

  if (query.isLoading) return false;

  if (query.error) return false;

  if (!query.data) return false;

  if (query.data.results.length <= 0) return false;

  return query.data.results.some((e) => e.status?.codeId === '15');
};
